<template>
  <v-dialog persistent scrollable width="700" style="backdrop-filter: blur(2px) grayscale(80%)" v-model="dialog">
    <template v-slot:activator="{ props: activatorProps }">
      <v-btn icon v-bind="activatorProps" density="compact" color="green" class="ml-1">
        <v-icon :icon="['fas', 'floppy-disk']" c/>
        <v-tooltip activator="parent" location="bottom">
          Сохранение
        </v-tooltip>
      </v-btn>
    </template>
    <template v-slot:default="{ isActive }">
      <v-card rounded="xl" class="ma-0 pa-0" density="compact">
        <template v-slot:title>
          СОХРАНИТЬ
        </template>
<!--        <template v-slot:subtitle v-if="prepared_docs">
          {{ prepared_docs.length }} {{ morph(prepared_docs.length, ['ДОКУМЕНТ', 'ДОКУМЕНТА', 'ДОКУМЕНТОВ']) }}?
        </template>-->
        <template v-slot:prepend>
          <v-btn
              :disabled="is_saving"
              flat
              :color="is_saving ? 'grey-lighten-4': 'red'"
              :icon="true"
              @click="isActive.value = false"
          >
            <v-icon :icon="['fas', 'xmark']" />
          </v-btn>
        </template>
        <template v-slot:append>
          <v-btn
              :loading="is_saving"
              :disabled="is_saving"
              flat
              :color="is_saving ? 'grey': 'green'"
              :icon="true"
              @click="save_all()"
          >
            <v-icon :icon="['fas', 'check']" />
          </v-btn>
        </template>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { EventsList } from "@/store/wp_planner/events.store";
import { TokenGUIDStore } from "@/store/global/SessionStore";
import { CurrentPeriod } from "@/store/wp_planner/main.store";
import moment from "moment";
import { Observers } from "@/store/wp_planner/misc.store";

export default {
  name: "SaveData__WP_Dialog",
  data() {
    return {
      dialog: false,
      is_saving: false
    }
  },
  methods: {
    save_all: async function () {
      this.is_saving = true
      await this.save_documents()
    },
    save_documents: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/wp/documents/save`
      let raw = {
        documents: this.prepared_docs
      }

      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: JSON.stringify(raw)
      }
      await fetch(url, properies)
          .then(async response => {
            if (response.ok) {
              return await response.json()
            } else {
              throw `Ошибка сохранения Документов!`
            }
          })
          .then(async result => {
            console.log(result)
            await this.save_observers()
          }).catch(err => {
            console.error(err)
          })
    },
    save_observers: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/wp/observers/save`

      let prepared_observers = this.observers.filter(el => moment(el.day).startOf('day') >= moment().startOf('day'))

      let raw = {
        observers: prepared_observers,
        district: this.$route.params.district
      }

      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: JSON.stringify(raw)
      }
      await fetch(url, properies)
          .then(async response => {
            if (response.ok) {
              return await response.json()
            } else {
              throw `Ошибка сохранения Документов!`
            }
          })
          .then(result => {
            console.log(result)
          }).catch(err => {
            console.error(err)
          }).finally(() => {
            location.reload()
          })
    }
  },
  computed: {
    session_token() {
      return TokenGUIDStore().get()
    },
    prepared_docs() {
      let docs = this.evs
      docs = docs.filter(ev => (!['2. Решено', '2. Закрыто'].includes(ev.status.name)))
      docs = docs.filter(ev => (moment(ev.date.desire) >= moment().startOf('day')))
      return docs
    },
    evs() {
      return EventsList().get()
    },
    current_period() {
      return CurrentPeriod().get()
    },
    observers() {
      return Observers().get()
    }
  }
}
</script>

<style scoped>

</style>
